import React from "react";
import { IconsType } from "../../../libs/Utils/types";

function Gift({ width, height, fill }: IconsType) {
  return (
    <div>
      <svg
        style={{
          width: width || "100%",
          height: height || "100%",
        }}
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.0273 3.53354L12.6832 4.25H13.478H14C14.5511 4.25 15 4.69889 15 5.25V7.5C15 7.63861 14.8886 7.75 14.75 7.75H1.25C1.11139 7.75 1 7.63861 1 7.5V5.25C1 4.69889 1.44889 4.25 2 4.25H2.26325H3.05648L2.71435 3.53434C2.57882 3.25085 2.5 2.94541 2.5 2.625C2.5 1.45364 3.45364 0.5 4.625 0.5C5.50499 0.5 6.46735 1.01116 7.48624 2.18802L7.86364 2.62393L8.24174 2.18863C9.05844 1.24836 10.054 0.5 11.1163 0.5C12.2876 0.5 13.2413 1.45364 13.2413 2.625C13.2413 2.94599 13.1629 3.25115 13.0273 3.53354ZM6.5435 4.25H6.8356L6.97905 3.99556C7.07678 3.8222 7.20486 3.60768 7.36325 3.36395L7.56008 3.06106L7.33435 2.77905C6.90294 2.24008 6.45693 1.80394 6.01233 1.49877C5.57183 1.19641 5.09909 1 4.625 1C3.72861 1 3 1.72861 3 2.625C3 3.52139 3.72861 4.25 4.625 4.25H6.5435ZM7.89892 3.46828L7.36578 4.25H8.312H11.1163C12.0126 4.25 12.7413 3.52139 12.7413 2.625C12.7413 1.72861 12.0126 1 11.1163 1C10.4148 1 9.77075 1.4092 9.25839 1.86763C8.7314 2.33914 8.26083 2.93764 7.89892 3.46828ZM7.75 14.5V10.25H8.25V14.5H7.75ZM2.5 13.5V10.25H5.25V14.5H3.5C2.94889 14.5 2.5 14.0511 2.5 13.5ZM12.5 14.5H10.75V10.25H13.5V13.5C13.5 14.0511 13.0511 14.5 12.5 14.5Z"
          fill="#D52B1E"
          stroke="#D52B1E"
        />
      </svg>
    </div>
  );
}

export default Gift;
